import {observer} from "mobx-react";
import React from "react";
import InputWithBorder from "@dropDesk/presentation/components/inputs/input_with_border";
import {ContentData} from "@dropDesk/presentation/pages/response_standard/modals/modal_crud/styled";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {useValidatorInputInternalChat} from "@dropDesk/presentation/pages/chat/ui/internal_chat/form/inputs/validator";
import InputChips from "@dropDesk/presentation/components/inputs/input_chips";


const InputsFormInternalChat = observer(
    ({
         internalChat,
         onUpdate,
         loading,
         onClickAddUser,
         onRemoveChip
     }: {
        internalChat: InternalChatEntity
        onUpdate: (internalChat: InternalChatEntity) => void,
        loading: boolean,
        onClickAddUser: () => void
        onRemoveChip: (idUser: string) => void
    }) => {

        const {
            errorMessageDescription,
            errorMessageUsers,
        } = useValidatorInputInternalChat(internalChat, loading);

        const handleAllChanges = (event: {
            target: { name: string; value: any; checked?: any; type: string };
        }) => {
            const _internalChat = internalChat!.copyWith({
                [event.target.name]: (event.target.type === "checkbox" || event.target.type === "switch") ? event.target.checked : event.target.value,
            });
            onUpdate(_internalChat);

        };

        return (
            <ContentData>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                    <InputWithBorder
                        autoFocus={true}
                        useEmojiPicker={true}
                        required={true}
                        name='description'
                        size={40}
                        disabled={loading}
                        placeHolder={loading && internalChat.isUnsaved() ? "Carregando..." : "Título do chat interno"}
                        messageError={errorMessageDescription}
                        label={"Descrição"}
                        value={internalChat?.description ?? ''}
                        onChange={handleAllChanges}
                    />
                    {internalChat.isUnsaved() && <InputChips
                        required={true}
                        name='users'
                        size={40}
                        marginTop={10}
                        disabled={loading}
                        placeHolder={loading && internalChat.isUnsaved() ? "Carregando..." : "Atendentes participantes do chat interno"}
                        messageError={errorMessageUsers}
                        label={"Atendentes participantes"}
                        chips={internalChat?.users?.map(internalChatUser => ({
                            id: internalChatUser.idUser,
                            description: internalChatUser.user?.name ?? 'Sem nome'
                        })) ?? []}
                        onRemoveChip={(chipId: string) => onRemoveChip(chipId)}
                        onClick={() => onClickAddUser()}
                    />}
                </div>
            </ContentData>
        )
    })
export default InputsFormInternalChat;
